import {
  plansAvailable,
  lastLicenseNumberAvailable,
} from "../../../globals/new-request.data";

export const newRequestState = {
  data: {
    managers: [],
    manager: "",
    rut: "",
    name: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    countryCode: "CL",
    emailConfirm: "",
    recaptcha: "",
    files: [],
    dispatchRegionOptions: [],
    dispatchData: {
      place: undefined,
      region: undefined,
      comuna: undefined,
      street: "",
      number: "",
      complement: "",
    },
    billInfo: {
      address: undefined,
      businessType: undefined,
      economicActivity: undefined,
      rut: undefined,
    },
    paymentType: null,
    netAmount: "",
    vehicleType: "",
    fuel_type: "",
    anual: "",
    billIssuer: "",
    planSelected: null,
    licenseNumber: "",
    dateOfIssue: null,

    isOwner: null,
    personType: null,
    personInfo: {
      countryCode: "CL",
      rut: "",
      name: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    },
    ownerBillInfo: {
      businessType: undefined,
      economicActivity: undefined,
      rut: "",
      phone: "",
      countryCode: "CL",
      email: "",
    },

    // information
    billIssuerSelected: null,
    plansAvailable: plansAvailable || [],
    licenseNumbersAvailable: lastLicenseNumberAvailable || [],
    billIssuerAvailable: [],
  },
  ui: {
    resumeStepIsDirty: false,
    planStepIsDirty: false,
    planStepErrors: [],
    generalDataStepIsDirty: false,
    generalDataStepErrors: [],
    dispatchStepIsDirty: false,
    dispatchStepErrors: [],
    paymentStepIsDirty: false,
    paymentStepErrors: [],
    acceptTermAndConditions: false,
    isReportSync: false,
    finished: false,
    disabledIsDirty: false,
  },
};
